import React, { useEffect } from "react";
import WOW from "wowjs";

import "swiper/swiper-bundle.css";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

function TestimonialsBrand({ dataBrands }) {
  useEffect(() => {
    const wow = new WOW.WOW({
      live: false, // This disables continuous scanning for new elements
    });
    wow.init();
  }, []);

  return (
    <div>
      <div className="testimonial-with-brand bg-1 bg_image">
        <div className="brand-area tmp-section-gapBottom">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="brand-inner tmp-section-gapTop">
                  <div className="section-head text-align-left">
                    <div className="section-sub-title">
                      <img
                        src="assets/images/services/section-custom-menubar.png "
                        alt="Corporate_service"
                      />
                      <span
                        className="subtitle wow slideInUp"
                        data-wow-duration=".4s"
                        data-wow-delay=".1s"
                      >
                        {dataBrands?.subTitle}
                      </span>
                    </div>
                    <h2
                      className="title split-collab wow slideInUp"
                      data-wow-duration=".4s"
                      data-wow-delay=".2s"
                    >
                      {dataBrands?.title}
                    </h2>
                  </div>

                  <ul
                    className="brand-list brand-style-1 justify-content-center justify-content-lg-between wow zoomIn"
                    data-sal-delay={150}
                    data-sal="slide-up"
                    data-sal-duration={800}
                  >
                    {dataBrands?.items.map((item) => {
                      return (
                        <li
                          key={item.id}
                          data-sal-delay={150}
                          data-sal="slide-up"
                          data-sal-duration={800}
                          className="sal-animate wow zoomIn"
                        >
                          <a style={{ cursor: "pointer" }}>
                            <img
                              width="150"
                              height="34"
                              src={item.logo}
                              alt="Brand_Image"
                            />
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestimonialsBrand;
